import { useContext, useEffect, useState } from 'react';
import { Box, Grid, InputLabel, Typography } from '@mui/material';
import { TreeItem, TreeView } from '@mui/x-tree-view';
import { ArrowDropDown, ArrowRight } from '@mui/icons-material';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { decryptURL } from 'utils/functions';
import { DropsContext } from 'contexts/DropsContext';
import { useDrawer } from 'components/Modals';
import VirtualDrop from 'components/VirtualDrop';
import Container from 'components/Container';
import Button from 'components/Button';
import Input from 'components/Input';
import api from 'services/api';

const findCategoriaById = (categorias, id) => {
  for (const categoria of categorias) {
    if (categoria?.id === id) return categoria;
    if (categoria?.children) {
      const found = findCategoriaById(categoria?.children, id);
      if (found) return found;
    }
  }
  return null;
};

const ListaCategorias = ({ categorias = [], onSelect }) => {
  const renderTree = (nodes) => (
    <TreeItem
      key={nodes?.id?.toString()}
      nodeId={nodes?.id?.toString()}
      label={
        <Typography
          py={1}
          variant={Array.isArray(nodes?.children) ? 'h6' : 'body1'}
          fontWeight={Array.isArray(nodes?.children) ? 'bold' : 'normal'}
        >
          {nodes?.nome}
        </Typography>
      }
    >
      {Array.isArray(nodes?.children) ? nodes?.children?.map(renderTree) : null}
    </TreeItem>
  );

  if (categorias?.length > 0) {
    return (
      <TreeView
        onNodeSelect={(_, nodeId) => onSelect(Number(nodeId))}
        defaultCollapseIcon={<ArrowDropDown />}
        defaultExpandIcon={<ArrowRight />}
      >
        {categorias?.map(renderTree)}
      </TreeView>
    );
  } else {
    return (
      <Box textAlign="center">
        <Typography variant="caption">Nenhuma categoria encontrada</Typography>
      </Box>
    );
  }
};

const Mercos = ({ id, integra_access_id, Header }) => {
  const { hash } = useParams();
  const navigate = useNavigate();
  const decrypt = hash ? decryptURL(hash) : null;
  const defaultValues = {
    id,
    integra_access_id,
    produto_id: decrypt?.produto_id || null,
    titulo: decrypt?.titulo || '',
    observacao: decrypt?.detalhes?.observacao || '',
    categoria_id: decrypt?.detalhes?.categoria_id || null,
  };
  const [loading, setLoading] = useState(false);
  const [categorias, setCategorias] = useState([]);
  const { openDrawer, closeDrawer } = useDrawer();
  const { drops } = useContext(DropsContext);
  const { control, watch, setValue, handleSubmit } = useForm({ defaultValues });
  const categoria_id = watch('categoria_id');
  const categoria = findCategoriaById(categorias, categoria_id);

  const getCategorias = async (params) => {
    try {
      setLoading(true);
      const { data } = await api.get(`Integracoes/Mercos/Envio`, { params });
      setCategorias(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onSelectCategoria = (id) => {
    const selected = findCategoriaById(categorias, id);
    if (!selected?.hasOwnProperty('children')) {
      setValue('categoria_id', id);
      closeDrawer();
    }
  };

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      await api.post(`/Integracoes/Mercos/Anuncio`, data);
      navigate(-1);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCategorias({ integra_access_id });
  }, []);

  return (
    <Container>
      <Header />
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <VirtualDrop
            name="produto_id"
            control={control}
            label="Produto"
            options={drops?.Produto?.filter((f) =>
              [
                '00-Mercadoria para revenda',
                '04-Produto acabado',
                '05-Subproduto',
                '06-Produto intermediário',
              ]?.includes(f?.tipolinha)
            )}
            onValueChange={(v) => setValue('titulo', v?.label || '')}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Input name="titulo" control={control} label="Título" />
        </Grid>
        <Grid item xs={12} display="flex" alignItems="center" gap={2}>
          <InputLabel>Categoria:</InputLabel>
          <Button
            color="primary"
            variant="outlined"
            onClick={() =>
              openDrawer(
                <ListaCategorias
                  categorias={categorias}
                  onSelect={onSelectCategoria}
                />,
                'Categorias'
              )
            }
          >
            {categoria?.nome ?? 'Selecione a Categoria'}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Input
            name="observacao"
            control={control}
            label="Observação"
            multiline
            rows={10}
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(onSubmit)}
            loading={loading}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Mercos;
